const DiodeQueryTypes = {
  BATCH: "batch-query"
};

export default DiodeQueryTypes;
